<template>
	<section>
		<b-modal :modelValue="showWalletSignatureModal" has-modal-card :can-cancel="cancelModal" @close="closeModal">
			<div class="modal-card terminal has-font-manrope onboard-card">

				
				<img v-if="wallet_type !== 'metamask' && walletIcon"  class="wallet-logo-other" :src="walletIcon" />
				<img v-else  class="wallet-logo" src="@/assets/icons/new/metamask-wallet.png" />

				<h1 class="get-mph-header mt-3">{{ $t('WALLET_SIGNATURE_HEAD') }}</h1>

				<p v-if="wallet_type !== 'metamask' && walletName"  class="is-size-14 is-line-height-20 mt-3 mb-20">{{ $t('WALLET_SIGNATURE_TEXT_OTHER', {wallet: walletName}) }}.</p>
				<p  v-else class="is-size-14 is-line-height-20 mt-3 mb-20">{{ $t('WALLET_SIGNATURE_TEXT') }}.</p>


			</div>
		</b-modal>
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useModalsStore } from '@/store/modules/modals';
import { mapActions, mapState } from 'pinia';
import { useUserStore } from '@/store/modules/user';
import { useContractStore } from '@/store/modules/contract';

export default defineComponent({
	name: 'WalletSignatureModal',
	components: {
		
	},
	data() {
		return {
			cancelModal: true,
			timeout: undefined as any
		};
	},
	computed: {
		...mapState(useModalsStore, {
			showWalletSignatureModal: (state) => state.showWalletSignatureModal,
		}),
		...mapState(useUserStore, {
			wallet_type: (state) => state.wallet_type,
		}),
		...mapState(useContractStore, {
			walletName: (state) => state.walletName,
			walletIcon: (state) => state.walletIcon,
		})

		
		
	},
	watch: {

	},
	beforeUnmount() {
	
	},
	async mounted() {
		this.timeout = setTimeout(() => {
			this.cancelModal = true;
		}, 5000);

	},
	methods: {

		...mapActions(useModalsStore, {
			toggleWalletSignatureModal: 'toggleWalletSignatureModal',
			
		}),
		closeModal() {
			if (this.timeout) {
				clearTimeout(this.timeout);
				this.timeout = undefined
			}
			this.toggleWalletSignatureModal(false);
		},
	}
});
</script>
<style scoped>
.modal-card {
	min-width: 400px;
	padding: 40px;
	align-items: center;
}


.modal-title {
	font-weight: 700;
	color: #333;
	font-size: 18px;
	line-height: 24px;
}

.wallet-logo-other {
	width: 80px;
	height: 80px;
	border-radius: 20px;

}
.wallet-logo {
	width: 80px;
	height: 80px;
}

.get-mph-header {
	color: #333;
	font-size: 28px;
	font-weight: 700;
	line-height: 2.25rem;
}

@media screen and (max-width: 500px) {
	.modal-card.terminal.onboard-card {
		min-width: 100%;
		max-width: inherit;
	}
}
</style>
